import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import Modal from "react-modal";
// @ts-expect-error
import { Document, Page, pdfjs } from "react-pdf";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnQBOGetBankAndOtherCurrentAssetAccountsDTO from "../../../models/DTO/IOnQBOGetBankAndOtherCurrentAssetAccountsDTO";
import IQBOGetBankAndOtherCurrentAssetAccountsDTO from "../../../models/DTO/IQBOGetBankAndOtherCurrentAssetAccountsDTO";
import IQBOGetLatestInvoiceDetailsDTO from "../../../models/DTO/IQBOGetLatestInvoiceDetailsDTO";
import IQBOGetPDFInvoiceDTO from "../../../models/DTO/IQBOGetPDFInvoiceDTO";
import IQBOMarkInvoicePaidDTO from "../../../models/DTO/IQBOMarkInvoicePaidDTO";
import IQBOOnGetLatestInvoiceDetailsDTO from "../../../models/DTO/IQBOOnGetLatestInvoiceDetailsDTO";
import IQBOSendInvoiceDTO from "../../../models/DTO/IQBOSendInvoiceDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IShipment_GroupUI from "../../../models/IShipment_GroupUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import IOnQBOGetPaymentMethodsDTO from "../../../models/QuickBooks Online/IOnQBOGetPaymentMethodsDTO";
import IQBOAccountDTO from "../../../models/QuickBooks Online/IQBOAccountDTO";
import IQBOGetPaymentMethodsDTO from "../../../models/QuickBooks Online/IQBOGetPaymentMethodsDTO";
import IQBOPaymentMethodDTO from "../../../models/QuickBooks Online/IQBOPaymentMethodDTO";
import UserTypesEnum from "../../../models/UserTypesEnum";

import SocketService from "../../../services/SocketService";
import OwButton from "../OwButton/OwButton";
import OwCheckbox from "../OwCheckbox/OwCheckbox";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import OwLabel from "../OwLabel/OwLabel";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import OwTitle from "../OwTitle/OwTitle";
import SquareChargeCustomer from "../SquareChargeCustomer/SquareChargeCustomer";
import "./PdfSidebarViewer.scss";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Socket } from "socket.io-client";
import { OwFnInput } from "../OwFnInput/OwFnInput";
import IQBOOnGetPDFInvoiceDTO from "../../../models/DTO/IQBOOnGetPDFInvoiceDTO";
import { QboAttachmentDropzone } from "../QboAttachmentDropzone/QboAttachmentDropzone";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type Props = {
    file: any;
    cancel: (refresh?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    shipmentGroupModel?: IShipment_GroupUI;
    shipmentGuid?: string;
    orderGuid?: string;
    vendorGuid: string;
    vendorEmail: string;
    qboVendorEmail: string;
    qboInvoiceTotal: number;
    qboEntityId: string;
    qboInvoiceId: string;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    email_type: string;
    shipmentModel: any;
    sendInvoiceActive: boolean;
    showInputDrawer: boolean;
    showPaymentInput: boolean;
    showEmailInput: boolean;
    showMarkPaidInput: boolean;
    markInvoicePaidActive: boolean;
    modalIsOpen: boolean;
    modalStyle: any;
    modalComponent: any;
    file: any;
    email?: string;
    payment_amount: number;
    check_reference?: string;
    release_commission: boolean;
    loadedPaymentMethods: boolean;
    loadedAssetAccounts: boolean;
    paymentMethods: IQBOPaymentMethodDTO[];
    payment_methods_id?: string;
    asset_account_id?: string;
    assetAccounts: IQBOAccountDTO[];
    showAttachments: boolean;
};

class PdfSidebarViewer extends Component<Props, State> {
    readonly state: State = {
        email_type: "orderwerks_email",
        shipmentModel: this.props.shipmentGroupModel,
        sendInvoiceActive: false,
        showInputDrawer: false,
        showPaymentInput: true,
        showEmailInput: false,
        showMarkPaidInput: false,
        markInvoicePaidActive: false,
        modalIsOpen: false,
        modalStyle: {
            content: {
                top: "9%",
                left: "38%",
                right: "38%",
                bottom: "18%",
                color: "#FFFFFF",
                backgroundColor: "#313439",
                border: "1px solid #44464a",
            },
            overlay: {
                backgroundColor: "rgba(68, 70, 74, 0.7)",
                zIndex: 1000,
            },
        },
        modalComponent: null,
        file: this.props.file || null,
        release_commission: true,
        loadedPaymentMethods: false,
        loadedAssetAccounts: false,
        paymentMethods: [],
        payment_methods_id: "",
        asset_account_id: "",
        assetAccounts: [],
        payment_amount: this.props.qboInvoiceTotal,
        showAttachments: false,
    };

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.QBOOnSendInvoice, this.onQboSendInvoice);
        this.props.socket.on(EndpointsEnum.QBOOnMarkInvoicePaid, this.onQboMarkInvoicePaid);
        this.props.socket.on(EndpointsEnum.QBOOnGetPDFInvoice, this.onQboGetPdfInvoice);
        this.props.socket.on(EndpointsEnum.QBOOnGetPaymentMethods, this.onQboGetPaymentMethods);
        this.props.socket.on(EndpointsEnum.QBOOnGetBankAndOtherCurrentAssetAccounts, this.onQboGetBankAndOtherCurrentAssetAccounts);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);
        this.props.socket.on(EndpointsEnum.QBOOnGetLatestInvoiceDetails, this.onQboGetLatestInvoiceDetails);

        this.qboGetLatestInvoiceDetails();

        if (this.props.userModel.isSupplierUser && this.props.userModel.userType?.id === UserTypesEnum.ADMIN) {
            this.qboGetPaymentMethods();
            this.qboGetAssetAccounts();
        }
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.QBOOnSendInvoice, this.onQboSendInvoice);
        this.props.socket.removeListener(EndpointsEnum.QBOOnMarkInvoicePaid, this.onQboMarkInvoicePaid);
        this.props.socket.removeListener(EndpointsEnum.QBOOnGetPDFInvoice, this.onQboGetPdfInvoice);
        this.props.socket.removeListener(EndpointsEnum.QBOOnGetPaymentMethods, this.onQboGetPaymentMethods);
        this.props.socket.removeListener(EndpointsEnum.QBOOnGetLatestInvoiceDetails, this.onQboGetLatestInvoiceDetails);
        this.props.socket.removeListener(
            EndpointsEnum.QBOOnGetBankAndOtherCurrentAssetAccounts,
            this.onQboGetBankAndOtherCurrentAssetAccounts
        );
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
    }

    getSquareChargeModalComponent = () => {
        return (
            <SquareChargeCustomer
                userModel={this.props.userModel}
                shipmentGroupModel={this.state.shipmentModel}
                socket={this.props.socket}
                closeModal={this.closeModal}
                supplierModel={this.props.supplierModel}
            />
        );
    };

    qboGetLatestInvoiceDetails = () => {
        if (this.props.qboEntityId) {
            const payload: IQBOGetLatestInvoiceDetailsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                invoiceEntityId: this.props.qboEntityId,
            };

            this.props.socket.emit(EndpointsEnum.QBOGetLatestInvoiceDetails, payload);
        }
    };

    onQboGetLatestInvoiceDetails = (data: IQBOOnGetLatestInvoiceDetailsDTO) => {
        this.setState({
            payment_amount: data.invoice.Balance,
        });
    };

    qboGetPaymentMethods = () => {
        const payload: IQBOGetPaymentMethodsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetPaymentMethods, payload);
    };

    onQboGetPaymentMethods = (data: IOnQBOGetPaymentMethodsDTO) => {
        this.setState({
            paymentMethods: data.paymentMethods,
            loadedPaymentMethods: true,
        });
    };

    qboGetAssetAccounts = () => {
        const payload: IQBOGetBankAndOtherCurrentAssetAccountsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetBankAndOtherCurrentAssetAccounts, payload);
    };

    onQboGetBankAndOtherCurrentAssetAccounts = (data: IOnQBOGetBankAndOtherCurrentAssetAccountsDTO) => {
        this.setState({
            assetAccounts: data.accounts,
            loadedAssetAccounts: true,
        });
    };

    openModal = (modalComponent: any) => {
        this.setState({
            modalIsOpen: true,
            modalComponent: modalComponent || null,
        });
    };

    afterOpenModal = () => {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    };

    closeModal = (shipmentModelUpdated: any) => {
        const state: any = {
            modalIsOpen: false,
            modalComponent: null,
        };

        if (!_.isNil(shipmentModelUpdated)) {
            state["shipmentModel"] = shipmentModelUpdated;
        }

        this.setState(state);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    handleEmailChange = (e: ChangeEvent<HTMLInputElement>, email_type: string) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
            email_type,
        };

        this.setState(state);
    };

    notify = (data: any) => {
        const showPaymentInput = false;
        let showEmailInput = false;

        if (this.state.sendInvoiceActive) {
            showEmailInput = true;
            console.log("props.shipmentModel", this.props.shipmentGroupModel);
        }

        this.setState({
            sendInvoiceActive: false,
            showInputDrawer: true,
            markInvoicePaidActive: false,
            showEmailInput,
            showPaymentInput,
        });
    };

    onQboSendInvoice = (data: any) => {
        this.setState(
            {
                sendInvoiceActive: false,
            },
            () => {
                const notification: INotification = {
                    message: "successfully_sent_invoice",
                    level: NotificationLevelEnum.success,
                    position: NotificationPositionEnum.bl,
                };

                this.props.notifyFn(null, notification);
                // this.props.cancel(); // TODO Do we want the sidebar to close when successfully sent?
            }
        );
    };

    downloadFile = () => {
        const blob = new Blob([this.props.file], { type: "application/pdf" }); // change resultByte to bytes

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const fileName = this.props.qboInvoiceId;

        link.download = _.get(this.props, "fileName", `${fileName}.pdf`);
        link.click();
    };

    printViewFile = () => {
        if (this.props.shipmentGroupModel) {
            const filename = encodeURIComponent(this.props.qboInvoiceId + " Invoice");
            const shipmentGroupGuid = this.props.shipmentGroupModel.guid;
            const token = this.props.userModel.token;

            const baseUrl = SocketService.getEndpointUrl();
            const url = `${baseUrl}/qbo/invoice/${shipmentGroupGuid}/${filename}?token=${token}`;
            const pdfWindow = window.open(url);
        }
    };

    toggleInvoiceEmail = () => {
        if (this.state.showEmailInput) {
            this.setState({
                showEmailInput: false,
                showInputDrawer: false,
                showMarkPaidInput: false,
                showAttachments: false,
            });
        } else {
            this.setState({
                showEmailInput: true,
                showInputDrawer: true,
                showMarkPaidInput: false,
                showAttachments: false,
            });
        }
    };

    toggleMarkPaid = () => {
        if (this.state.showMarkPaidInput) {
            this.setState({
                showMarkPaidInput: false,
                showInputDrawer: false,
                showEmailInput: false,
                showAttachments: false,
            });
        } else {
            this.setState({
                showMarkPaidInput: true,
                showInputDrawer: true,
                showEmailInput: false,
                showAttachments: false,
            });
        }
    };

    toggleAttachments = () => {
        if (this.state.showAttachments) {
            this.setState({
                showAttachments: false,
                showInputDrawer: false,
                showEmailInput: false,
                showMarkPaidInput: false,
            });
        } else {
            this.setState({
                showAttachments: true,
                showInputDrawer: true,
                showEmailInput: false,
                showMarkPaidInput: false,
            });
        }
    };

    sendInvoice = () => {
        this.setState(
            {
                sendInvoiceActive: true,
            },
            () => {
                const payload: IQBOSendInvoiceDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                };

                if (this.props.shipmentGuid) {
                    payload.shipmentGroupGuid = this.props.shipmentGuid;
                }

                if (this.props.orderGuid) {
                    payload.orderGuid = this.props.orderGuid;
                }

                if (this.state.email && this.state.email.length) {
                    payload.email = this.state.email;
                }

                this.props.socket.emit(EndpointsEnum.QBOSendInvoice, payload);
            }
        );
    };

    markInvoicePaid = () => {
        if (this.state.payment_amount) {
            this.setState(
                {
                    markInvoicePaidActive: true,
                },
                () => {
                    const paymentMethod = this.state.paymentMethods.find((method) => {
                        if (method.Id === this.state.payment_methods_id) {
                            return method;
                        }
                    });

                    const depositToAccount = this.state.assetAccounts.find((account) => {
                        if (account.Id === this.state.asset_account_id) {
                            return account;
                        }
                    });

                    if (!paymentMethod) {
                        this.setState({
                            markInvoicePaidActive: false,
                        });
                    } else {
                        const payload: IQBOMarkInvoicePaidDTO = {
                            userToken: this.props.userModel.token,
                            userGuid: this.props.userModel.guid,
                            supplierGuid: this.props.supplierModel.guid,
                            paymentDetail: {
                                amount: this.state.payment_amount.toString(),
                                checkReference: this.state.check_reference,
                                paymentMethod: {
                                    Id: paymentMethod.Id,
                                    Name: paymentMethod.Name,
                                },
                                depositToAccount: {
                                    Id: depositToAccount?.Id,
                                    Name: depositToAccount?.Name,
                                },
                            },
                            releaseCommission: this.state.release_commission,
                        };

                        if (this.props.shipmentGuid) {
                            payload.shipmentGroupGuid = this.props.shipmentGuid;
                        }

                        if (this.props.orderGuid) {
                            payload.orderGuid = this.props.orderGuid;
                        }

                        this.props.socket.emit(EndpointsEnum.QBOMarkInvoicePaid, payload);
                    }
                }
            );
        }
    };

    onQboMarkInvoicePaid = (data: any) => {
        const notification: INotification = {
            message: "successfully_applied_payment",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                showMarkPaidInput: false,
                showInputDrawer: false,
                shipmentModel: data,
                markInvoicePaidActive: false,
                file: null,
            },
            () => {
                this.qboGetPdfInvoice();
            }
        );
    };

    qboGetPdfInvoice = () => {
        const payload: IQBOGetPDFInvoiceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.props.vendorGuid,
            supplierGuid: this.props.supplierModel.guid,
        };

        if (this.props.shipmentGuid) {
            payload.shipmentGroupGuid = this.props.shipmentGuid;
        }

        if (this.props.orderGuid) {
            payload.orderGuid = this.props.orderGuid;
        }

        this.props.socket.emit(EndpointsEnum.QBOGetPDFInvoice, payload);
    };

    onQboGetPdfInvoice = (data: IQBOOnGetPDFInvoiceDTO) => {
        this.setState({
            file: data.data,
        });
    };

    showPaymentInput = () => {};

    showChargeModal = () => {
        this.openModal(this.getSquareChargeModalComponent());
    };

    render() {
        const vendorHasSquare = !!_.get(this.props.shipmentGroupModel, "Vendor.Vendor_Integration.square_customer_id", 0);
        const supplierHasSquare = _.get(this.props.shipmentGroupModel, "Supplier.Supplier_Integration.has_square", false);
        const hasSquareCharge = !!_.get(this.state.shipmentModel, "square_transaction_id", false);
        const hasMarkedPaid = !!_.get(this.state.shipmentModel, "qbo_InvoicePaid", false);

        console.log("hasMarkedPaid", hasMarkedPaid);

        let square_btn_title = "charge_with_square";

        if (hasSquareCharge) {
            square_btn_title = "view_charge";
        }

        return (
            <div className="PdfSidebarViewer">
                <div className="header">
                    <div className="">
                        <OwButton
                            className={"btn-sm btn-primary me-2"}
                            fn={this.downloadFile}
                            leftIconClass={"fas fa-download"}
                            title={"download"}
                        />

                        {this.props.shipmentGroupModel ? (
                            <OwButton
                                className={"btn-sm btn-primary me-2"}
                                fn={this.printViewFile}
                                leftIconClass={"fas fa-print"}
                                title={"print_view"}
                            />
                        ) : null}

                        <div className={"d-inline-flex"}>
                            <div className={"btn-group"} role={"group"}>
                                <OwButton
                                    className={"btn-sm btn-secondary"}
                                    fn={this.toggleInvoiceEmail}
                                    leftIconClass={"fas fa-at"}
                                    title={"send_invoice"}
                                    active={this.state.sendInvoiceActive}
                                    disabled={this.state.sendInvoiceActive}
                                />

                                {this.props.userModel.isSupplierUser && this.props.userModel.userType?.id === UserTypesEnum.ADMIN ? (
                                    <React.Fragment>
                                        <OwButton
                                            className={vendorHasSquare && supplierHasSquare ? "btn-sm btn-warning" : "d-none"}
                                            fn={this.showChargeModal}
                                            leftIconClass={"fas fa-credit-card"}
                                            title={square_btn_title}
                                        />

                                        <OwButton
                                            disabled={this.state.markInvoicePaidActive || hasMarkedPaid}
                                            active={this.state.markInvoicePaidActive}
                                            className={"btn-sm btn-success"}
                                            fn={this.toggleMarkPaid}
                                            leftIconClass={"fas fa-dollar-sign"}
                                            title={"mark_invoice_paid"}
                                        />

                                        <OwButton
                                            className={"btn-sm btn-warning me-2"}
                                            fn={this.toggleAttachments}
                                            leftIconClass={"fas fa-paperclip"}
                                            title={"attachments"}
                                        />
                                    </React.Fragment>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <OwButton
                            centerIconClass={"far fa-times"}
                            className={"btn-danger"}
                            fn={() => {
                                this.props.cancel();
                            }}
                        />
                    </div>
                </div>
                <div className={supplierHasSquare ? "text-warning" : "d-none"}>
                    <a href={"/users"} className={vendorHasSquare ? "d-none" : "pointer"}>
                        <OwLabel
                            leftIconClass={"fas fa-exclamation-triangle"}
                            className={"text-warning ms-2 pointer"}
                            title={"vendor_not_square_connected"}
                            supplierModel={this.props.supplierModel}
                            isSupplierVendorOverride={true}
                        />
                        <span> - </span>
                        <span style={{ textDecoration: "underline" }}>
                            <OwLabel title={"fix"} className={"text-primary pointer"} />
                        </span>
                    </a>
                </div>
                <div className={this.state.showInputDrawer ? "d-flex justify-content-center mb-2" : "d-none"}>
                    <div className={this.state.showEmailInput ? "w-75" : "d-none"}>
                        <div className={"mb-2"}>
                            <OwTitle tag={"h5"} title={"email"} className={"mb-0 pb-2"} />
                            <div>
                                <OwLabel
                                    className={"font-weight-bold w-40 pointer"}
                                    title={"orderwerks_email"}
                                    internalComponent={
                                        <OwInputWrapper
                                            type={"radio"}
                                            name={"email"}
                                            fn={(e: any) => {
                                                this.handleEmailChange(e, "orderwerks_email");
                                            }}
                                            value={this.props.vendorEmail}
                                        />
                                    }
                                />

                                {this.props.vendorEmail}
                            </div>
                            <div>
                                <OwLabel
                                    className={"font-weight-bold w-40 pointer"}
                                    title={"quickbooks_email"}
                                    internalComponent={
                                        <OwInputWrapper
                                            type={"radio"}
                                            name={"email"}
                                            fn={(e: any) => {
                                                this.handleEmailChange(e, "quickbooks_email");
                                            }}
                                            value={this.props.qboVendorEmail}
                                        />
                                    }
                                />

                                {this.props.qboVendorEmail}
                            </div>
                            <OwLabel
                                className={"font-weight-bold w-40 pointer"}
                                title={"manual"}
                                internalComponent={
                                    <OwInputWrapper
                                        type={"radio"}
                                        name={"email"}
                                        fn={(e: any) => {
                                            this.handleEmailChange(e, "manual");
                                        }}
                                        value={this.state.email}
                                    />
                                }
                            />

                            <OwInputWrapper
                                value={this.state.email}
                                fn={this.handleChange}
                                name={"email"}
                                className={"form-control-sm mt-2"}
                                disabled={this.state.email_type !== "manual" ? true : false}
                            />
                        </div>
                        <div>
                            <OwButton className={"btn-sm btn-primary"} title={"send"} fn={this.sendInvoice} />
                        </div>
                    </div>

                    <div className={this.state.showMarkPaidInput ? "" : "d-none"}>
                        <div>
                            <OwLabel title={"payment_amount"} noBottomMargin={true} />
                            <OwFnInput
                                type={"number"}
                                value={this.state.payment_amount}
                                fn={this.handleChange}
                                name={"payment_amount"}
                                className={"form-control-sm"}
                            />
                        </div>
                        <div className={"mt-2"}>
                            <OwLabel title={"payment_method"} noBottomMargin={true} />
                            <OwSelectOption
                                valueProp={"Id"}
                                titleProp={"Name"}
                                options={this.state.paymentMethods}
                                name={"payment_methods_id"}
                                fn={this.handleChange}
                                showBlankFirst={true}
                            />
                        </div>
                        <div className={"mt-2"}>
                            <OwLabel title={"payment_ref_optional"} noBottomMargin={true} />
                            <OwInputWrapper
                                value={this.state.check_reference}
                                fn={this.handleChange}
                                name={"check_reference"}
                                className={"form-control-sm"}
                            />
                        </div>
                        <div className={"mt-2"}>
                            <OwLabel title={"asset_account_optional"} noBottomMargin={true} />
                            <OwSelectOption
                                valueProp={"Id"}
                                titleProp={"Name"}
                                options={this.state.assetAccounts}
                                name={"asset_account_id"}
                                fn={this.handleChange}
                                showBlankFirst={true}
                            />
                        </div>
                        <div className={"mt-2"}>
                            <OwCheckbox
                                label={"release_commission"}
                                fn={this.handleChange}
                                name={"release_commission"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={this.state.release_commission}
                            />
                        </div>
                        <div className={"mt-2"}>
                            <OwButton title={"send"} fn={this.markInvoicePaid} />
                        </div>
                    </div>
                </div>
                {this.props.qboEntityId && (
                    <div className={"mb-2 px-2"}>
                        {this.state.showAttachments && (
                            <QboAttachmentDropzone
                                qboEntityId={this.props.qboEntityId}
                                onError={(error) => {
                                    this.props.notifyFn({ message: error, eid: "qbo-attachment-error" });
                                }}
                            />
                        )}
                    </div>
                )}
                <div style={{ height: "95vh", overflow: "scroll" }}>
                    {this.state.file ? (
                        <Document
                            className="vh-95"
                            file={this.state.file}
                            // onLoadSuccess={this.onDocumentLoadSuccess}
                            // onLoadError={this.onDocumentLoadError}
                            // onSourceSuccess={this.onDocumentSourceSuccess}
                            // onSourceError={this.onDocumentSourceError}
                        >
                            <Page pageNumber={1} />
                        </Document>
                    ) : null}
                </div>

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    style={this.state.modalStyle}
                    closeTimeoutMS={250}>
                    {this.state.modalComponent}
                </Modal>
            </div>
        );
    }
}

export default PdfSidebarViewer;
